import React from 'react';
export const CFIconLinkedinLogo = {
    alias: 'linkedin',
    defaultTitle: 'Linkedin',
    source: ({ Path }) => (React.createElement(Path, { d: 'M22.394 0H1.944C.964 0 .174.77.174 1.73v20.54c0 .96.79 1.73 1.77 1.73h20.45c.98 0 1.78-.78 1.78-1.73V1.73c0-.96-.8-1.73-1.78-1.73Zm-15.1 20.45h-3.56V8.99h3.56v11.46ZM5.514 7.43a2.06 2.06 0 1 1 0-4.12c1.15 0 2.06.92 2.06 2.06 0 1.14-.92 2.06-2.06 2.06Zm15.11 13.02h-3.56v-5.57c0-1.33-.02-3.04-1.85-3.04s-2.13 1.45-2.13 2.94v5.66h-3.55V8.98h3.41v1.57h.05c.47-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.29h-.01Z' })),
};
